import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#usePriceSummary">usePriceSummary(props)</a> ⇒ <inlineCode><a href="#PriceSummaryTalonProps">PriceSummaryTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains logic for a price summary component.
It performs effects and returns prop data for rendering the component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Log a GraphQL error if it occurs when getting the price summary`}</li>
        </ul>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#FlattenedData">FlattenedData</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Query data flattened into a simple object.`}</p>
      </dd>
      <dt><a href="#PriceSummaryQueries">PriceSummaryQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for price summary component.`}</p>
      </dd>
      <dt><a href="#PriceSummaryTalonProps">PriceSummaryTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Props used for rendering a price summary component.`}</p>
      </dd>
    </dl>
    <p>{`This talon contains logic for a price summary component.
It performs effects and returns prop data for rendering the component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Log a GraphQL error if it occurs when getting the price summary`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#PriceSummaryQueries"
            }}><inlineCode parentName="a">{`PriceSummaryQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for a price summary component.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { usePriceSummary } from '@magento/peregrine/lib/talons/CartPage/PriceSummary/usePriceSummary';
`}</code></pre>
    <p>{`Query data flattened into a simple object.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`subtotal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cart subtotal (excluding tax)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`total`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cart grand total`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`discounts`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Applied discounts to the cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftCards`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gift cards applied to the cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftOptions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Gift Options applied to the cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`taxes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Taxes applied to the cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shipping`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Shipping addresses associated with this cart`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL queries for price summary component.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceSummary/priceSummary.js"
      }}>{`priceSummary.js`}</a>{`
for the queries used in Venia.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getPriceSummary`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query to get the price summary for a cart`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Props used for rendering a price summary component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleProceedToCheckout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function which navigates the browser to the checkout * @property {function} handleEnterKeyPress Callback function which navigates the browser to the checkout at the press of enter key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hasError`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if a GraphQL query returns an error. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hasItems`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the cart has any items. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isLoading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True while the GraphQL query is still in flight. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`flatData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#FlattenedData"
            }}><inlineCode parentName="a">{`FlattenedData`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query data that has been flattened into a simple object`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/PriceSummary/usePriceSummary.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/PriceSummary/usePriceSummary.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      